/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A user with an active role in an organization listed on an event, for team assembly.
 * @export
 * @interface EventOrganizationMemberRead
 */
export interface EventOrganizationMemberRead {
    /**
     * 
     * @type {string}
     * @memberof EventOrganizationMemberRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventOrganizationMemberRead
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof EventOrganizationMemberRead
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventOrganizationMemberRead
     */
    last_name?: string | null;
}

/**
 * Check if a given object implements the EventOrganizationMemberRead interface.
 */
export function instanceOfEventOrganizationMemberRead(value: object): value is EventOrganizationMemberRead {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function EventOrganizationMemberReadFromJSON(json: any): EventOrganizationMemberRead {
    return EventOrganizationMemberReadFromJSONTyped(json, false);
}

export function EventOrganizationMemberReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventOrganizationMemberRead {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'username': json['username'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
    };
}

export function EventOrganizationMemberReadToJSON(json: any): EventOrganizationMemberRead {
    return EventOrganizationMemberReadToJSONTyped(json, false);
}

export function EventOrganizationMemberReadToJSONTyped(value?: EventOrganizationMemberRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'username': value['username'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
    };
}

